<template>
  <div class="container">
    <p><b>PERSONAL DATA PROTECTION NOTICE</b></p>
    <p>
      <b><i>PEMBERITAHUAN PERLINDUNGAN DATA PRIBADI</i></b>
    </p>
    <p></p>
    <p style="padding-top:24px">Dear Valued Users and Guests,</p>
    <p><i>Para Pengguna dan Pengunjung yang Kami Hormati,</i></p>
    <p>
      This Personal Data Protection Notice (“Notice”) is issued to all valued
      users and guests of PT. Car Some Indonesia and its affiliate (“Carsome”)
      pursuant to applicable laws and regulations of Republic of Indonesia
      concerning Personal Data Protection (“PDP Laws”).
    </p>
    <p>
      <i>Pemberitahuan Perlindungan Data Peribadi ini (“Pemberitahuan”)
        dikeluarkan bagi seluruh Pengguna dan Pengunjung Carsome dan afiliasinya
        (“Carsome”) yang kami hormati sesuai dengan ketentuan peraturan
        perundang-undangan Republik Indonesia yang berlaku terkait Perlindungan
        Data Pribadi (“UU PDP”).
        </i>
    </p>
    <ul>
      <li>
        <p>
          1.&nbsp;&nbsp;&nbsp;During your course of dealing with us, we will
          collect and process your personal data for purposes, including, to
          communicate with you, provide products and/or services to you, respond
          to your enquiries, provide information and updates on our products,
          services and promotions offered by Carsome and other purposes required
          to operate and maintain our business as set out in our Personal Data
          Protection Policy (collectively referred to as “Purposes”).
        </p>
      </li>
      <li>
        <p>
          <i
            >1.&nbsp;&nbsp;&nbsp;Selama anda berhubungan dengan kami, kami akan
            mengumpulkan dan memproses data pribadi anda untuk tujuan
            berkomunikasi dengan anda, menyediakan produk dan/atau layanan
            kepada anda, memberi tanggapan terhadap pertanyaan anda, memberi
            anda update terkini mengenai produk, layanan dan/atau promosi yang
            ditawarkan oleh Carsome serta tujuan-tujuan lain yang diperlukan
            untuk mengoperasikan dan mempertahankan usaha kami sepertimana yang
            tercantum pada Kebijakan Perlindungan Data Pribadi kami (secara
            bersama-sama disebut sebagai “Tujuan”).</i
          >
        </p>
      </li>
      <li>
        <p>
          2.&nbsp;&nbsp;&nbsp;We are committed to ensuring that your personal
          data is stored securely. You have the right to request for access to,
          request for a copy of, request to update or correct your personal data
          held by us. You have the right at any time to request us to limit the
          processing and use of your personal data. Your written request should
          be addressed to our Compliance Officer at &lt;<a
            href="mailto:info@carsome.id"
            target="_blank"
            ><u>info@carsome.id</u></a
          >&gt;.
        </p>
      </li>
      <li>
        <p>
          <i
            >2.&nbsp;&nbsp;&nbsp;Kami berkomitmen untuk memastikan bahwa data
            pribadi anda akan disimpan dengan aman. Anda berhak untuk meminta
            akses, meminta salinan, meminta untuk memperbaharui atau memperbaiki
            data pribadi anda yang disimpan oleh kami. Anda mempunyai hak setiap
            waktu untuk meminta kami membatasi pemrosesan dan penggunaan data
            pribadi anda. Permintaan tertulis dapat anda tujukan kepada Petugas
            Kepatuhan kami melalui </i
          >&lt;<a href="mailto:info@carsome.id" target="_blank"
            ><u>info@carsome.id</u></a
          >&gt;<i>.</i>
        </p>
      </li>
      <li>
        <p>
          3.&nbsp;&nbsp;&nbsp;This Notice is provided in English and Bahasa
          Indonesia languages and should there be any conflict in meaning
          between the English and Bahasa Indonesia language version, the Bahasa
          Indonesia language version shall prevail. By accessing this website
          and/or submitting your personal data to us, you are deemed to have
          read, understood and accepted the terms of this Notice, and consent to
          the collection and processing of your personal data by Carsome as per
          this Notice and our Personal Data Protection Policy.
        </p>
      </li>
      <li>
        <p>
          <i
            >3.&nbsp;&nbsp;&nbsp;Pemberitahuan ini disediakan dalam Bahasa
            Inggris dan Bahasa Indonesia dan apabila terdapat perbedaan makna
            antara versi Bahasa Inggris dan Bahasa Indonesia, maka versi bahasa
            Indonesia yang akan berlaku. Dengan mengakses laman web ini dan/atau
            menyerahkan data peribadi anda kepada kami, anda dianggap telah
            membaca, memahami dan menerima syarat-syarat Pemberitahuan ini, dan
            memberikan persetujuan kepada Carsome untuk mengumpulkan dan
            mengolah data pribadi anda sesuai dengan Pemberitahuan ini dan
            Kebijakan Perlindungan Data Pribadi.</i
          >
        </p>
      </li>
      <li>
        <p>
          4.&nbsp;&nbsp;&nbsp;We reserve the right to update and amend this
          Personal Data Protection Notice and our Personal Data Protection
          Policy from time to time. We will notify you of any amendments via
          announcements on our website or other appropriate means.
        </p>
      </li>
      <li>
        <p>
          <i
            >4.&nbsp;&nbsp;&nbsp;Kami berhak untuk memuktahirkan dan mengubah
            Pemberitahuan Perlindungan Data Peribadi ini dan Kebijakan
            Perlindungan Data Pribadi kami dari waktu ke waktu. Kami akan
            memberitahukan anda setiap perubahan melalui pengumuman pada laman
            web kami atau melalui cara lain yang tepat.</i
          >
        </p>
      </li>
    </ul>
    <p>Dated: January 1, 2021</p>
    <p><i>Tanggal: 1 Januari 2021</i></p>
    <p>&emsp;</p>
    <h2>PERSONAL DATA PROTECTION POLICY</h2>
    <h2>1. INTRODUCTION</h2>
    <ul>
      <li>
        <p>
          1.1 This Policy applies to personal information about individuals
          (including but not limited to customers, vendors, distributors,
          suppliers, service providers, joint venture/business partners, job
          applicants, employees) held by us. We will only process your Personal
          Data in accordance with the applicable laws and regulations of
          Republic of Indonesia concerning Personal Data Protection
          (collectively referred to as the “PDP Laws”) as well as this Policy.
        </p>
      </li>
      <li>
        <p>
          1.2 By providing your Personal Data to us and/or continuing to access
          and use our website (“Site”), you declare that you have read and
          understood this Policy and agree to us processing your Personal Data
          in accordance with the manner as set out in this Policy.
        </p>
      </li>
      <li>
        <p>
          1.3 We reserve the right to modify, update and/or amend this Policy
          from time to time. We will notify you of any amendments via
          announcements on the Site or other appropriate means. Please check the
          Site from time to time to see if there are amendments to this Policy.
        </p>
      </li>
      <li>
        <p>
          1.4 In the event you do not agree to this Policy or any amendments to
          this Policy, we may not be able to render all services to you and you
          may be required to terminate your relevant agreement with us and/or
          stop accessing or using the Site.
        </p>
      </li>
    </ul>
    <h2>2. COLLECTION</h2>
    <ul>
      <li>
        <p>
          2.1 The term “Personal Data” means any information in our possession
          or control that relates directly or indirectly to an individual to the
          extent that the individual can be identified or are identifiable from
          that and other information in our possession, such as name, address,
          telephone number, Identification/Passport number, date of birth,
          photograph, email address, household information, etc. as well as
          other Personal Data as defined under the PDP Laws.
        </p>
      </li>
      <li>
        <p>
          2.2 The types of Personal Data collected depend on the purpose of
          collection. We may process your Personal Data by way of collecting,
          recording, holding, storing, using and/or disclosing it.
        </p>
      </li>
      <li>
        <p>
          2.3 Your Personal Data may be collected from you during your course of
          dealings with us in any way or manner including pursuant to any
          transactions and/or communications made from/with us. We may also
          collect your Personal Data from a variety of sources, including
          without limitation, at any events, seminars, road shows, customer
          satisfaction surveys organised and/or sponsored by us, as well as from
          publicly available sources.
        </p>
      </li>
      <li>
        <p>
          2.4 In addition, we may also receive, store and process your Personal
          Data which are legally provided or made available by any third
          parties, financial institutions, regulatory and law enforcement
          authorities, for reasons including delivery of our products and/or
          services, performance of conditions of agreements and/or to comply
          with our legal and regulatory obligations.
        </p>
      </li>
      <li>
        <p>
          2.5 The Personal Data as provided/furnished by you to us or collected
          by us from you or through such other sources as may be necessary for
          the fulfilment of the purposes at the time it was sought or collected,
          may be processed for the following purposes (collectively referred to
          as the “Purposes”):
        </p>
      </li>
      <li>
        <ul>
          <li><p>(a) to communicate with you;</p></li>
          <li><p>(b) to maintain and improve customer relationship;</p></li>
          <li>
            <p>
              (c) to assess, process and provide products, services and/or
              facilities to you;
            </p>
          </li>
          <li>
            <p>
              (d) to administer and process any payments related to products,
              services and/or facilities requested by you;
            </p>
          </li>
          <li><p>(e) to establish your identity and background;</p></li>
          <li>
            <p>
              (f) to respond to your enquiries or complaints and resolve any
              issues and/or disputes which may arise in connection with any
              dealings with us;
            </p>
          </li>
          <li>
            <p>
              (g) to provide you with information and/or updates on our
              products, services, upcoming promotions offered by us and/or
              events organised by us and selected third parties which may be of
              interest to you from time to time;
            </p>
          </li>
          <li>
            <p>
              (h) for direct marketing purposes via SMS, phone call, email, fax,
              mail, social media and/or any other appropriate communication
              channels;
            </p>
          </li>
          <li>
            <p>
              (i) to facilitate your participation in, and our administration
              of, any events including contests, promotions or campaigns;
            </p>
          </li>
          <li><p>(j) to award points in a loyalty or rewards programme;</p></li>
          <li><p>(k) to maintain and update internal record keeping;</p></li>
          <li><p>(l) for internal administrative purposes;</p></li>
          <li>
            <p>
              (m) to send you seasonal greetings messages from time to time;
            </p>
          </li>
          <li>
            <p>
              (n) to send you the invitation to join our events, promotions and
              product launch events;
            </p>
          </li>
          <li>
            <p>
              (o) to monitor, review and improve our events, promotions,
              products and/or services;
            </p>
          </li>
          <li>
            <p>
              (p) to conduct credit worthiness checks and establish your
              creditworthiness, where necessary, in providing you with the
              products, services and/or facilities;
            </p>
          </li>
          <li>
            <p>
              (q) to administer and give effect to your commercial transactions
              with us (such as a tender award, contract for service, tenancy
              agreement);
            </p>
          </li>
          <li>
            <p>
              (r) to process any payments related to your commercial
              transactions with us;
            </p>
          </li>
          <li>
            <p>
              (s) to process and analyse your Personal Data either individually
              or collectively with other individuals;
            </p>
          </li>
          <li>
            <p>
              (t) to conduct market research or surveys, internal marketing
              analysis, customer profiling activities, analysis of customer
              patterns and choices, planning and statistical and trend analysis
              in relation to our products and/or services;
            </p>
          </li>
          <li>
            <p>
              (u) to share any of your Personal Data with the auditor for our
              internal audit and reporting purposes;
            </p>
          </li>
          <li>
            <p>
              (v) to share any of your Personal Data pursuant to any agreement
              or document which you have duly entered with us for purposes of
              seeking legal and/or financial advice and/or for purposes of
              commencing legal action;
            </p>
          </li>
          <li>
            <p>
              (w) to share any of your Personal Data with our joint
              venture/business partners to jointly develop products and/or
              services or launch marketing campaigns;
            </p>
          </li>
          <li>
            <p>
              (x) to share any of your Personal Data with insurance companies
              necessary for the purpose of applying and obtaining insurance
              policy(ies), if necessary;
            </p>
          </li>
          <li>
            <p>
              (y) to share any of your Personal Data with financial institutions
              necessary for the purpose of applying and obtaining credit
              facility(ies), if necessary;
            </p>
          </li>
          <li><p>(z) for audit, risk management and security purposes;</p></li>
          <li>
            <p>
              (aa) for detecting, investigating and preventing fraudulent,
              prohibited or illegal activities;
            </p>
          </li>
          <li>
            <p>
              (bb) for enabling us to perform our obligations and enforce our
              rights under any agreements or documents that we are a party to;
            </p>
          </li>
          <li>
            <p>
              (cc) to transfer or assign our rights, interests and obligations
              under any agreements entered into with us;
            </p>
          </li>
          <li>
            <p>
              (dd) for meeting any applicable legal or regulatory requirements
              and making disclosure under the requirements of any applicable
              law, regulation, direction, court order, by-law, guideline,
              circular or code applicable to us;
            </p>
          </li>
          <li>
            <p>
              (ee) to enforce or defend our rights and your rights under, and to
              comply with, our obligations under the applicable laws,
              legislation and regulations;
            </p>
          </li>
          <li>
            <p>
              (ff) to carry out verification and background checks as part of
              any recruitment and selection process in connection with your
              application for employment with us; and/or
            </p>
          </li>
          <li>
            <p>
              (gg) for other purposes required to operate, maintain and better
              manage our business and your relationship with us, which we notify
              you of at the time of obtaining your consent; and you agree and
              consent to us using and processing your Personal Data for the
              Purposes in the manner as identified in this Policy. If you do not
              consent to us processing your Personal Data for one or more of the
              Purposes, please notify us at the contact details below.
            </p>
          </li>
        </ul>
      </li>
      <li>
        <p>
          2.6 The collection of your Personal Data by us may be mandatory or
          voluntary in nature depending on the Purposes for which your Personal
          Data is collected. Where it is obligatory for you to provide us with
          your Personal Data, and you fail or choose not to provide us with such
          data, or do not consent to the above or this Policy, we will not be
          able to provide products and/or services or otherwise deal with you.
        </p>
      </li>
    </ul>
    <h2>3. DISCLOSURE</h2>
    <p>
      We will not sell, rent, transfer or disclose any of your Personal Data to
      any third party without your consent. However, we may disclose your
      Personal Data to the following third parties, for one or more of the above
      Purposes:
    </p>
    <ul>
      <li>
        <p>
          (a) Between Carsome and our related corporations and affiliates either
          in Malaysia or overseas;
        </p>
      </li>
      <li>
        <p>
          (b) your immediate family members and/or emergency contact person as
          may be notified to us from time to time;
        </p>
      </li>
      <li><p>(c) successors in title to us;</p></li>
      <li>
        <p>
          (d) any person under a duty of confidentiality which we have engaged
          to discharge our obligations to you, to whom has undertaken to keep
          your Personal Data confidential;
        </p>
      </li>
      <li>
        <p>
          (e) any party in relation to legal proceedings or prospective legal
          proceedings;
        </p>
      </li>
      <li>
        <p>
          (f) our auditors, consultants, lawyers, accountants or other financial
          or professional advisers appointed in connection with our business on
          a strictly confidential basis, appointed by us to provide services to
          us;
        </p>
      </li>
      <li>
        <p>
          (g) any party nominated or appointed by us either solely or jointly
          with other service providers, for purpose of establishing and
          maintaining a common database where we have a legitimate common
          interest;
        </p>
      </li>
      <li>
        <p>
          (h) data centres and/or servers located within or outside Malaysia for
          data storage purposes or otherwise;
        </p>
      </li>
      <li>
        <p>
          (i) payment channels including but not limited to financial
          institutions for purpose of assessing, verifying, effectuating and
          facilitating payment of any amount due to us in connection with your
          purchase of our products and/or services;
        </p>
      </li>
      <li>
        <p>
          (j) government agencies, law enforcement agencies, courts, tribunals,
          regulatory bodies, industry regulators, ministries, and/or statutory
          agencies or bodies, offices or municipality in any jurisdiction, if
          required or authorised to do so, to satisfy any applicable law,
          regulation, order or judgment of a court or tribunal or queries from
          the relevant authorities;
        </p>
      </li>
      <li>
        <p>
          (k) our joint venture/business partners, third-party product and/or
          service providers, suppliers, vendors, contractors, data processors or
          agents, that provide related products and/or services in connection
          with our business, or discharge or perform one or more of the above
          Purposes and other purposes required to operate and maintain our
          business, including but not limited to call centres, telecommunication
          companies, logistics companies, information technology companies and
          data centres;
        </p>
      </li>
      <li>
        <p>
          (l) insurance companies for the purpose of applying and obtaining
          insurance policy(ies), if necessary;
        </p>
      </li>
      <li>
        <p>
          (m) financial institutions for the purpose of applying and obtaining
          credit facility(ies), if necessary;
        </p>
      </li>
      <li>
        <p>
          (n) financial institutions, merchants and credit card organisations in
          connection with your commercial transactions with us;
        </p>
      </li>
      <li>
        <p>
          (o) the general public when you become a winner in a contest by
          publishing your name, photographs and other Personal Data without
          compensation for advertising and publicity purposes;
        </p>
      </li>
      <li>
        <p>
          (p) to third-party credit reporting or employment agencies as part of
          the recruitment and selection process and/or otherwise in connection
          with your application for employment with us;
        </p>
      </li>
      <li>
        <p>
          (q) in the event of a potential, proposed or actual sale/disposal of
          any of our business or interest, merger, acquisition, consolidation,
          re-organisation, funding exercise or asset sale relating to us, or in
          the event of winding-up (“Transaction”), your Personal Data may be
          required to be disclosed or transferred to a third party as a result
          of or in connection with, the Transactions.
        </p>
      </li>
      <li>
        <p>
          (r) You hereby acknowledge that such disclosure and transfer may occur
          and therefore permit us to disclose and transfer your Personal Data to
          such third party and its advisors/representatives and/or any other
          person reasonably requiring the same in order for us to operate and
          maintain our business or carry out the activities set out in the
          Purposes.
        </p>
      </li>
    </ul>
    <h2>4. ACCURACY</h2>
    <p>
      We aim to keep all Personal Data as accurate, complete, not misleading,
      up-to-date and reliable as possible. Therefore, the accuracy of your
      Personal Data depends to a large extent on the information you provide. As
      such, it is a condition of us providing the products, services and/or
      facilities to you that you:
    </p>
    <ul>
      <li>
        <p>
          (a) warrant and declare that all your Personal Data submitted or to be
          submitted to us are accurate, not misleading, updated and complete in
          all respects for purposes of acquiring or using the relevant products,
          services and/or facilities, and you have not withheld any Personal
          Data which may be material in any respect and that we are authorised
          to assume the accuracy and up-to-dateness of the Personal Data given
          by you when processing such Personal Data); and
        </p>
      </li>
      <li>
        <p>
          (b) promptly update us as and when such Personal Data provided earlier
          to us becomes inaccurate, incomplete, misleading, outdated or changes
          in any way whatsoever by contacting us at the contact details below.
        </p>
      </li>
    </ul>
    <h2>5. ACCESS</h2>
    <ul>
      <li>
        <p>
          5.1 Subject to the exceptions provided under the PDP Laws, you have
          the right to request for access to, for a copy of, to update or
          correct, your Personal Data held by us. We may charge a small fee to
          cover the administration costs involved in processing your request to
          access your Personal Data.
        </p>
      </li>
      <li>
        <p>
          5.2 In respect of your right to access and/or correct your Personal
          Data, we have the right to refuse your request to access and/or
          correct your Personal Data for the reasons permitted under the law,
          such as where the expense of providing access to you is
          disproportionate to the risks to your privacy, or where the rights of
          others may also be violated, amongst other reasons.
        </p>
      </li>
      <li>
        <p>
          5.3 You have the right at any time to request us to limit the
          processing and use of your Personal Data (for example, requesting us
          to stop sending you any marketing and promotional materials or
          contacting you for marketing purposes).
        </p>
      </li>
      <li>
        <p>
          5.4 In addition, you also have the right, by notice in writing, to
          inform us on your withdrawal (in full or in part) of your consent
          given previously to us subject to any applicable legal restrictions,
          contractual conditions and a reasonable duration of time for the
          withdrawal of consent to be affected. However, your withdrawal of
          consent could result in certain legal consequences arising from such
          withdrawal. In this regard, depending on the extent of your withdrawal
          of consent for us to process your Personal Data, it may mean that we
          will not be able to continue with your existing relationship with us
          and/or the contract that you have with us will have to be terminated.
        </p>
      </li>
    </ul>
    <h2>6. RETENTION</h2>
    <p>
      Any of your Personal Data provided to us is retained for as long as the
      Purposes for which the Personal Data was collected continues. Your
      Personal Data will be destroyed from our records and system in accordance
      with our retention policy. In the event your Personal Data is no longer
      required for the said Purposes unless its further retention is required to
      satisfy a longer retention period to meet our operational, legal,
      regulatory, tax or accounting requirements.
    </p>
    <h2>7. SECURITY</h2>
    <ul>
      <li>
        <p>
          7.1 We are committed to ensuring that your Personal Data is stored
          securely. In order to prevent unauthorised access, disclosure or other
          similar risks, we endeavour, where practicable, to implement
          appropriate technical, physical, electronic and procedural security
          measures in accordance with the applicable laws and regulations and
          industry standard to safeguard against and prevent the unauthorised or
          unlawful processing of your Personal Data, and the destruction of, or
          accidental loss, damage to, alteration of, unauthorised disclosure of
          or access to your Personal Data.
        </p>
      </li>
      <li>
        <p>
          7.2 We will make reasonable updates to its security measures from time
          to time and ensure the authorised third parties only use your Personal
          Data for the Purposes set out in this Policy.
        </p>
      </li>
      <li>
        <p>
          7.3 The Internet is not a secure medium. However, we will put in place
          various security procedures with regard to the Site and your
          electronic communications with us. All our employees, joint
          venture/business partners, agents, contractors, vendors, suppliers,
          data processors, third-party product and/or service providers, who
          have access to, and are associated with the processing of your
          Personal Data, are obliged to respect the confidentiality of your
          Personal Data.
        </p>
      </li>
      <li>
        <p>
          7.4 Please be aware that communications over the Internet, such as
          emails/webmails are not secure unless they have been encrypted. Your
          communications may be routed through a number of countries before
          being delivered – this is the nature of the World Wide Web/Internet.
        </p>
      </li>
      <li>
        <p>
          7.5 We cannot and do not accept responsibility for any unauthorised
          access or interception or loss of Personal Data that is beyond our
          reasonable control.
        </p>
      </li>
    </ul>
    <h2>8. TRANSFER OUTSIDE OF INDONESIA</h2>
    <p>
      Our information technology storage facilities and servers may be located
      in other jurisdictions outside of Indonesia. This may include, but not
      limited to, instances where your Personal Data may be stored on servers
      located outside Indonesia. In addition, your Personal Data may be
      disclosed or transferred to entities located outside Indonesia or where
      you access the Site from countries outside Indonesia. Please note that
      these foreign entities may be established in countries that might not
      offer a level of data protection that is equivalent to that offered in
      Indonesia under the laws of Republic of Indonesia. You hereby expressly
      consent to us transferring your Personal Data outside of Indonesia for
      such purposes. We shall endeavour to ensure that reasonable steps are
      taken to procure that all such third parties outside of Indonesia shall
      not use your Personal Data other than for that part of the Purposes and to
      adequately protect the confidentiality and privacy of your Personal Data.
    </p>
    <h2>9. EXTERNAL LINKS</h2>
    <ul>
      <li>
        <p>
          9.1 If any part of the Site links you to other websites, those
          websites do not operate under this Policy. Your act of accessing other
          websites shall be at your own risk. Even though we may provide links
          that may link to other websites, the existence of such links should
          not be construed as part of the Site, and we do not accept any
          responsibility or liability arising from those websites.
        </p>
      </li>
      <li>
        <p>
          9.2 Likewise, if you subscribe to an application, content or a product
          from our strategic partner and you subsequently provide your Personal
          Data directly to that third party, that Personal Data will be subject
          to that third party’s privacy/personal data protection policy (if they
          have such a policy) and not to this Policy.
        </p>
      </li>
      <li>
        <p>
          9.3 We recommend you to read and understand the privacy/personal data
          protection statement/policy posted on those other websites in order to
          understand their procedures for collecting, processing, using and
          disclosing personal data and before submitting your Personal Data to
          those websites.
        </p>
      </li>
    </ul>
    <h2>10. COOKIES</h2>
    <ul>
      <li>
        <p>
          10.1 We employ an industry standard technology called “cookies”. The
          cookie is a small piece of information stored on the hard drive of
          your computer or device for record-keeping purposes and is used by us
          to track your visits to the Site. Cookies may be used to save your
          preferences for your ease and convenience when using the Site. Third
          party advertising networks may issue their separate cookies to your
          hard drive when serving advertisements.
        </p>
      </li>
      <li>
        <p>
          10.2 The type of anonymous clickstream data collected by us through
          the cookies may include your Internet Protocol address, web browser
          software, date and time of visit to the Site, and whether your
          requests (including search requests and clicking on links to parts of
          the Site) were met with success. All such information collected
          through cookies is not Personal Data and you cannot be identified from
          this information. Such information is only used for the purpose of
          managing and creating a better user experience and to identify areas
          for improvement on the Site.
        </p>
      </li>
      <li>
        <p>
          10.3 The use of cookies is now an industry standard, and you will find
          them used on most major websites. Most browsers are initially set up
          to accept cookies. If you prefer, you can reset your browser either to
          notify you when you have received a cookie or to refuse to accept
          cookies. You should understand that certain features on the Site will
          not function properly if you set your browser to not accept cookies.
        </p>
      </li>
    </ul>
    <h2>11. CONTACT</h2>
    <p>
      In the event you have any questions about this Policy, have any further
      queries, or would like to make a complaint, data access, correction
      request in respect of your Personal Data, you may contact our Compliance
      Officer at &lt;<a href="mailto:info@carsome.id" target="_blank"
        ><u>info@carsome.id</u></a
      >&gt;.
    </p>
    <h2>12. LANGUAGE</h2>
    <p>
      In the event of any conflict between this English language Personal Data
      Protection Policy and its corresponding Bahasa Indonesia Personal Data
      Protection Policy, the terms in this English language Personal Data
      Protection Policy shall prevail.
    </p>
    <p><b>Dated: January 1, 2021</b></p>
    <p></p>
    <h2><i>KEBIJAKAN PERLINDUNGAN DATA PRIBADI</i></h2>
    <h2><i>1. PENDAHULUAN</i></h2>
    <ul>
      <li>
        <p>
          <i
            >1.1 Kebijakan ini berlaku terhadap informasi pribadi mengenai
            individu (termasuk namun tidak terbatas kepada pelanggan, vendor,
            distributor, supplier, pemberi jasa, joint venture/rekanan bisnis,
            pelamar kerja, karyawan) yang disimpan oleh kami. Kami hanya akan
            memproses Data Pribadi anda berdasarkan peraturan perundang-undangan
            Republik Indonesia yang berlaku terkait Perlindungan Data Pribadi
            (secara bersama-sama disebut sebagai “UU PDP”) serta Kebijakan
            ini.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >1.2 Dengan memberikan Data Pribadi anda kepada kami dan/atau dengan
            cara terus-menerus mengakses dan menggunakan laman web kami (“Laman
            Web”), anda menyatakan bahwa anda telah membaca dan memahami
            Kebijakan ini dan setuju dengan pemrosesan Data Pribadi anda
            berdasarkan cara yang ditetapkan dalam Kebijakan ini.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >1.3 Kami berhak untuk mengubah, memuktahirkan dan /atau mengubah
            Kebijakan ini dari waktu ke waktu. Kami akan memberitahukan anda
            atas setiap perubahan melalui pengumuman di Laman Web atau cara lain
            yang tepat. Silahkan memeriksa Laman Web dari waktu ke waktu untuk
            mengetahui setiap adanya perubahan terhadap Kebijakan ini.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >1.4 Jika anda tidak setuju dengan Kebijakan ini atau setiap
            perubahan terhadap Kebijakan ini, kami tidak dapat memberikan semua
            layanan kami kepada anda dan anda dipersyarakan untuk mengakhiri
            perjanjian anda yang berkaitan dengan kami dan/atau berhenti
            mengakses atau menggunakan Laman Web ini.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>2. PENGUMPULAN</i></h2>
    <ul>
      <li>
        <p>
          <i
            >2.1 Istilah “Data Pribadi” berarti setiap informasi yang kami
            miliki atau berada di bawah kendali kami yang berkaitan secara
            langsung atau tidak langsung kepada suatu individu sepanjang
            individu tersebut dapat diidentifikasi atau dapat dikenali melalui
            informasi tersebut dan informasi lainnya yang kami miliki seperti
            nama, alamat, nomor telepon, nomor KTP / passport, tanggal lahir,
            gambar, alamat e-mail, informasi rumah, dan sebagainya, serta Data
            Pribadi lainnya sebagaimana dimaksud di dalam UU PDP.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >2.2 Jenis Data Pribadi yang dikumpulkan bergantung pada tujuan
            pengumpulan. Kami dapat “memproses” Data Pribadi anda dengan cara
            mengumpulkan, merekam, menyimpan, menggunakan dan / atau
            mengungkapkannya.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >2.3 Data Pribadi anda dapat dikumpulkan dari anda selama anda
            berhubungan dengan kami dalam apa cara apapun termasuk melalui
            setiap transaksi dan/atau komunikasi yang dibuat dari / dengan kami.
            Kami juga dapat mengumpulkan Data Pribadi anda dari berbagai sumber,
            termasuk namun tidak terbatas pada, setiap acara, seminar, road
            show, survey kepuasan pelanggan yang diselenggarakan dan/atau
            disponsori oleh kami, serta dari sumber-sumber lainya yang tersedia
            secara umum.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >2.4 Di samping itu, kami juga dapat menerima, menyimpan dan
            memproses Data Pribadi anda yang tersedia atau disediakan secara
            legal oleh pihak ketiga, lembaga keuangan, regulator dan aparat
            penegak hukum, karena alasan-alasan termasuk penyampaian produk
            dan/atau layanan kami, pelaksanaan syarat-syarat perjanjian dan/atau
            mematuhi kewajiban hukum dan perundang-undangan kami.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >2.5 Data Pribadi yang disampaikan/diberikan oleh anda kepada kami
            atau yang dikumpulkan oleh kami dari anda atau melalui sumber-sumber
            lainnya yang mungkin diperlukan untuk memenuhi tujuan-tujuan pada
            saat Data Pribadi tersebut diminta atau dikumpulkan, dapat diolah
            untuk tujuan-tujuan berikut (secara Bersama-sama disebut sebagai
            “Tujuan”):</i
          >
        </p>
      </li>
      <li>
        <ul>
          <li>
            <p><i>(a) untuk berkomunikasi dengan anda;</i></p>
          </li>
          <li>
            <p>
              <i
                >(b) untuk mmenjaga dan meningkatkan hubungan dengan
                pelanggan;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(c) untuk menilai, memproses dan menyediakan produk, layanan
                dan / atau fasilitas-fasilitas kepada anda;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(d) untuk mengelola dan memproses setiap pembayaran yang
                berkaitan dengan produk, layanan dan/atau fasilitas-fasilitas
                yang anda minta;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i>(e) untuk membuktikan identitas dan latar belakang anda;</i>
            </p>
          </li>
          <li>
            <p>
              <i
                >(f) untuk merespon setiap pertanyaan atau pengaduan anda dan
                menyelesaikan setiap permasalahan dan/atau sengketa yang mungkin
                timbul akibat hubungan anda dengan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(g) untuk memberikan anda informasi dan / atau update terkini
                mengenai produk, layanan, promosi yang akan ditawarkan oleh kami
                dan / atau acara yang diselenggarakan oleh kami dan pihak ketiga
                terpilih yang mungkin dapat menarik minat anda dari waktu ke
                waktu;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(h) untuk tujuan pemasaran langsung melalui SMS, panggilan
                telepon, e-mail, faksimili, surat, media sosial dan / atau
                saluran komunikasi lainnya yang sesuai;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(i) untuk memudahkan keikusertaan anda, dan pengurusan kami,
                dalam setiap acara termasuk kontes, promosi atau campaign;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i>(j) memberi poin award dalam program loyalti atau reward;</i>
            </p>
          </li>
          <li>
            <p>
              <i
                >(k) untuk memelihara dan memuktahirkan penyimpanan rekaman
                internal;</i
              >
            </p>
          </li>
          <li>
            <p><i>(l) untuk tujuan administratif internal;</i></p>
          </li>
          <li>
            <p>
              <i>(m) untuk mengirimkan ucapan musiman dari waktu ke waktu;</i>
            </p>
          </li>
          <li>
            <p>
              <i
                >(n) untuk mengirimkan undangan untuk menghadiri event dan
                promosi kami dan acara peluncuran produk kepada anda;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(o) untuk memantau, mereview dan meningkatkan kualitas event,
                promosi, produk dan / atau layanan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(p) untuk melaksanakan pemeriksaan kelayakan kredit dan
                mewujudkan kelayakan kredit anda, dimana perlu, dalam
                menyediakan produk, layanan dan / atau fasilitas-fasilitas
                kepada anda;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(q) untuk mengelola dan menjalankan transaksi komersial anda
                dengan kami (seperti pemberian tender, kontrak untuk layanan,
                perjanjian penyewaan);</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(r) untuk memproses setiap pembayaran yang berkaitan dengan
                transaksi komersial anda dengan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(s) untuk memproses dan menganalisis Data Pribadi anda secara
                individu atau secara kolektif dengan individu lainnya;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(t) untuk melaksanakan riset pasar atau survey, analisa
                pemasaran internal, aktivitas profil pelanggan, analisis pola
                dan pilihan pelanggan, perencanaan dan analisa statistik dan
                trend terkait dengan produk dan / atau layanan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(u) untuk membagikan Data Pribadi anda kepada pihak auditor
                untuk tujuan audit internal dan pelaporan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(v) untuk membagikan Data Pribadi anda berdasarkan setiap
                perjanjian atau dokumen yang telah anda buat dengan kami untuk
                tujuan mendapatkan nasihat hukum dan / atau keuangan dan / atau
                untuk memulai suatu tindakan hukum;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(w) untuk membagikan setiap Data Pribadi anda kepada usaha
                patungan /partner bisnis kami untuk bersama-sama mengembangkan
                produk dan / atau layanan atau meluncurkan marketing
                campaign;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(x) untuk membagikan setiap Data Pribadi anda kepada perusahaan
                asuransi yang diperlukan untuk tujuan pengajuan dan memperoleh
                polis asuransi, apabila diperlukan;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(y) untuk membagikan setiap Data Pribadi anda dengan lembaga
                keuangan yang diperlukan untuk tujuan pengajuan dan memperoleh
                fasilitas pembiayaan, apabila diperlukan;</i
              >
            </p>
          </li>
          <li>
            <p><i>(z) untuk tujuan audit, managemen risiko dan keamanan;</i></p>
          </li>
          <li>
            <p>
              <i
                >(aa) untuk mendeteksi, menginvestigasi dan menghindari tindakan
                penipuan, akitvitas-aktivitas yang dilarang atau yang melanggar
                kententuan undang-undang;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(bb) untuk membolehkan kami dalam melaksanakan tanggungjawab
                kami dan melaksanakan hak kami berdasarkan perjanjian atau
                dokumen yang dibuat antara anda dan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(cc) untuk memindahkan atau mengalihkan hak, kepentingan dan
                kewajiban kami berdasarkan setiap perjanjian yang dibuat antara
                anda dan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(dd) untuk mematuhi setiap ketentuan perundang-undangan yang
                berlaku dan persyaratan hukum dan melakukan pengungkapan
                berdasarkan persyaratan setiap ketentuan undang-undang,
                regulasi, perintah, perintah pengadilan, peraturan-peraturan
                turunan, pedoman, surat edaran atau kode etik yang berlaku
                terhadap kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(ee) untuk melaksanakan atau mempertahankan hak-hak kami dan
                hak-hak anda, dan untuk mematuhi kewajiban kami, berdasarkan
                hukum dan regulasi yang berlaku;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(ff) untuk melaksanakan verifikasi dan pemeriksaan latar
                belakang sebagai bagian dari proses perekrutan dan seleksi
                karyawan terkait dengan aplikasi pekerjaan anda kepada kami; dan
                / atau</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >(gg) untuk tujuan lain yang diperlukan untuk mengoperasikan,
                menjaga dan mengelola kegiatan bisnis kami dan hubungan anda
                dengan kami dengan lebih baik, yang telah kami beritahukan
                kepada anda pada saat kami mendapatkan persetujuan anda; dan
                anda sepakat dan memberikan persetujuan kepada kami untuk
                menggunakan dan mengolah Data Pribadi anda untuk Tujuan dengan
                cara-cara yang disampaikan di dalam Kebijakan ini. Apabila anda
                tidak menyetujui kami untuk mengolah Data Pribadi anda atas satu
                atau lebih dari Tujuan di atas, silahkan menghubungi kami pada
                rincian kontak di bawah.</i
              >
            </p>
          </li>
        </ul>
      </li>
      <li>
        <p>
          <i
            >2.6 Pengumpulan Data Pribadi anda oleh kami mungkin bersifat wajib
            atau sukarela tergantung pada Tujuan yang mana Data Pribadi anda
            tersebut dikumpulkan. Apabila anda diwajibkan untuk menyediakan Data
            Pribadi anda kepada kami, dan anda gagal atau memilih untuk tidak
            memberikan data tersebut kepada kami, atau tidak setuju dengan
            Kebijakan tersebut di atas, maka kami tidak akan dapat menyediakan
            produk dan / atau layanan atau melakukan hubungan lainnya dengan
            anda.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>3. PENGUNGKAPAN</i></h2>
    <p>
      <i
        >Kami tidak akan menjual, menyewakan, memindahkan atau mengungkapkan
        setiap Data Pribadi anda kepada pihak ketiga manapun tanpa persetujuan
        anda. Namun demikian, kami dapat mengungkapkan Data Pribadi anda kepada
        pihak ketiga berikut, untuk satu atau lebih dari Tujuan di atas:</i
      >
    </p>
    <ul>
      <li>
        <p>
          <i
            >(a) &nbsp;Antara Carsome dan perusahaan-perusahaan terkait dan
            afiliasi kami yang berada di Indonesia maupun di luar negeri;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(b) &nbsp;keluarga terdekat anda dan / atau kontak darurat anda
            yang dibertahukan kepada kami dari waktu ke waktu;</i
          >
        </p>
      </li>
      <li>
        <p><i>(c) &nbsp;penerima pengalihan hak kami;</i></p>
      </li>
      <li>
        <p>
          <i
            >(d) &nbsp;setiap orang yang memiliki kewajiban menjaga kerahsiaan
            yang telah kami tunjuk untuk untuk melaksanakan kewajiban kami
            kepada anda, yang telah berjanji untuk menjaga kerahasiaan Data
            Pribadi anda;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(e) &nbsp;setiap pihak yang terakit dengan proses hukum yang ada
            atau yang akan ada;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(f) &nbsp;auditor, konsultan, konsultan hukum, akuntan atau
            penasihat keuangan atau profesional lainnya yang ditunjuk berkaitan
            dengan kegiatan usaha kami berdasarkan kerahasiaan yang ketat, yang
            telah kami tunjuk untuk menyediakan jasanya kepada kami;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(g) &nbsp;setiap pihak yang dinominasikan atau ditunjuk oleh kami
            baik sendiri-sendiri atau bersama-sama dengan penyedia layanan
            lainnya, dengan tujuan membuat dan memelihara pangkalan data bersama
            di mana kami memiliki kepentingan bersama yang sah;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(h) &nbsp;pusat data dan / atau server yang terletak di dalam atau
            di luar Indonesia untuk tujuan penyimpanan data atau sebaliknya;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(i) &nbsp;saluran pembayaran termasuk tetapi tidak terbatas pada
            institusi keuangan untuk tujuan penilaian, pengesahan, melaksanakan
            dan menfasilitasi setiap pembayaran yang terhutang kepada kami
            berkaitan dengan pembelian produk dan / atau layanan kami;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(j) &nbsp;badan-badan pemerintahan, lembaga-lembaga penegak hukum,
            pengadilan, badan peradilan, badan pengatur, regulator industri,
            kementerian, dan / atau badan atau lembaga perundang-undangan,
            pejabat atau pemerintahan daerah dari setiap yurisdiksi, jika
            dipersyaratkan atau memiliki kewenangan atas hal tersebut, untuk
            memastikan kepatuhan terhadap hukum, peraturan, perintah atau
            putusan pengadilan atau lembaga peradilan atau menjawab pertanyaan
            dari otoritas terkait;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(k) &nbsp;perusahaan patungan/rekanan bisnis kami, penyedia produk
            dan / atau layanan pihak ketiga, supplier, vendor, kontraktor, pihak
            pengolah data atau agen, yang menyediakan produk dan / atau layanan
            terkait dengan bisnis kami, atau menunaikan atau melaksanakan satu
            atau lebih dari Tujuan di atas dan tujuan lain yang diperlukan untuk
            mengoperasikan dan menjaga bisnis kami, termasuk tetapi tidak terhad
            kepada call center, perusahaan telekomunikasi, perushaan logistik,
            perusahaan teknologi dan pusat data;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(l) &nbsp;perusahaan asuransi untuk proses pengajuan dan memperoleh
            polis asuransi, apabila diperlukan;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(m) &nbsp;lembaga keuangan untuk tujuan pengajuan dan mendapatkan
            fasilitas kredit (jika ada);</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(n) &nbsp;lembaga keuangan, merchant dan perusahaan kartu
            kreditberkaitan dengan setiap transaksi komersial anda dengan
            kami;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(o) &nbsp;publik pada umumnya apabila anda menjadi pemenang dalam
            suatu sayembara dengan mempublikasikan nama, gambar dan Data Pribadi
            lain mili anda tanpa adanya imbalan untuk tujuan pengiklanan dan
            publisitas;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(p) &nbsp;kepada agensi pelaporan kredit atau agensi penyedia
            tenaga kerja pihak ketiga sebagai bagian daripada proses rekrutmen
            dan seleksi dan/atau yang berkaitan dengan proses lamaran pekerjaan
            anda kepada kami;</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(q) &nbsp;dalam hal terjadi penjualan/pelepasan dari setiap
            kegiatan usaha atau kepentingan kami, merger, akuisisi, konsolidasi,
            re-organisasi, pelaksanaan pembiayaan atau penjualan aset baik yang
            bersifat potensial, direncanakan atau aktual, atau dalam hal
            terjadinya pembubaran usaha (“Transaksi”), Data Pribadi anda mungkin
            dipersyaratkan untuk diungkapkan atau dialihkan kepada pihak ketiga
            sebagai akibat, atau berkaitan dengan, Transaksi.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(r) &nbsp;Anda dengan ini mengakui bahwa pengungkapan dan
            pengalihan tersebut dapat terjadi dan olehkarenanya mengizinkan kami
            untuk melakukan pengungkapan dan pengalihan Data Pribadi anda kepada
            pihak ketiga dan penasihat / perwakilannya; dan / atau setiap pihak
            lain yang secara wajar mempersyaratkan hal tersebut agar kami dapat
            mengoperasikan dan memelihara bisnis kami atau menjalankan
            aktivitas-aktivitas yang tercantum di dalam Tujuan.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>4. AKURASI</i></h2>
    <p>
      <i
        >Kami berniat untuk menyimpan semua Data Pribadi dengan seakurat,
        lengkap, tidak menyesatkan, terkini dan seterpercaya mungkin. Oleh
        karenanya, keakuratan Data Pribadi anda sangat bergantung pada informasi
        yang anda berikan. Dengan demikian, sebagai syarat bagi kami dalam
        menyediakan produk, layanan dan / atau fasilitas kepada anda, anda:</i
      >
    </p>
    <ul>
      <li>
        <p>
          <i
            >(a) menjamin dan menyatakan bahwa seluruh Data Pribadi yang
            disampaikan atau akan disampaikan kepada kami adalah akurat, tidak
            menyesatkan, terkini dan lengkap dalam segala aspeknya untuk tujuan
            memperoleh atau menggunakan produk, layanan dan / atau fasilitas
            yang terkait, dan anda tidak menahan setiap Data Pribadi yang
            mungkin bersifat material dalam segala aspeknya dan kami dengan ini
            diberikan kewenangan untuk menganggap Data Pribadi yang diberikan
            oleh anda ketika memproses Data Pribadi tersebut bersifat akurat dan
            terkini); dan</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >(b) memberitahukan kepada kami sesegera mungkin apabila Data
            Pribadi yang disampaikan kepada kami sebelumnya menjadi tidak
            akurat, tidak lengkap, menyesatkan, usang atau berubah dengan cara
            apapun dengan menghubungi kami melalui rincian kontak di bawah.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>5. AKSES</i></h2>
    <ul>
      <li>
        <p>
          <i
            >5.1 Tunduk kepada pengecualian yang terdapat di dalam UU PDP, anda
            memiliki hak untuk meminta akses kepada, meminta salinan, melakukan
            pengkinian atau memperbaiki, Data Pribadi anda yang disimpan oleh
            kami. Kami mungkin akan mengenakan biaya yang kecil untuk menutup
            biaya administrasi yang diperlukan dalam memproses permintaan anda
            untuk mengakses Data Pribadi anda.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >5.2 Terkait dengan hak anda untuk mengakses dan / atau memperbaiki
            Data Pribadi anda, kami berhak untuk menolak permintaan anda untuk
            mengakses dan / atau memperbaiki Data Pribadi anda berdasarkan
            alasan yang dibenarkan berdasarkan ketentuan hukum, antara lain
            seperti ketika risiko menyediakan akses kepada anda tidak sepadan
            dengan risiko terhadap hak privasi anda, atau ketika terdapat hak
            orang lain yang dilanggar.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >5.3 Anda mempunyai hak untuk setiap saat meminta kami untuk
            membatasi pemprosesan dan penggunaan Data Pribadi anda (sebagai
            contoh, meminta kami untuk berhenti mengirimkan anda setiap materi
            pemasaran dan promosi atau menghubungi anda untuk tujuan
            pemasaran).</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >5.4 Sebagai tambahan, anda juga memiliki hak, melalui pemberitahuan
            secara tertulis, untuk memberitahukan kami tentang penarikan kembali
            persetujuan anda (baik seluruhnya atau sebagian) yang telah
            diberikan sebelumnya kepada kami tunduk pada setiap pembatasan yang
            dipersyaratkan oleh undang-undang yang berlaku, persyaratan kontrak
            dan durasi waktu yang wajar bagi penarikan kembali persetujuan
            tersebut untuk dilaksanakan. Namun demikian, penarikan kembali
            persetujuan anda mungkin dapat mengakibatkan konsekuensi hukum
            tertentu yang timbul akibat penarikan kembali tersebut. Sehubungan
            dengan tersebut, bergantung pada sejauh mana penarikan kembali
            persetujuan anda berdampak terhadap kewenangan kami untuk mengolah
            Data Pribadi anda, penarikan tersebut mungkin mengakibatkan kami
            tidak akan dapat meneruskan hubungan yang telah ada diantara anda
            dan kami dan/atau perjanjian-perjanjian yang anda miliki dengan kami
            akan diakhiri.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>6. PENYIMPANAN</i></h2>
    <p>
      <i
        >Setiap Data Pribadi yang anda berikan kepada kami akan disimpan selama
        Tujuan untuk mana Data Pribadi tersebut dikumpulkan terus berlangsung.
        Data Pribadi anda akan dimusnahkan dari arsip dan sistem kami
        berdasarkan kebijakan penyimpanan kami. Apabila Data Pribadi anda tidak
        lagi diperlukan untuk Tujuan tersebut kecuali apabila diperlukan
        penyimpanan lebih lanjut untuk memenuhi jangka waktu penyimpanan yang
        lebih panjang dalam rangka memenuhi persyaratan operasi, hukum,
        perundang-undangan, perpajakan atau pembukuan kami.</i
      >
    </p>
    <h2><i>7. KEAMANAN</i></h2>
    <ul>
      <li>
        <p>
          <i
            >7.1 Kami berkomitmen untuk memastikan bahwa Data Pribadi anda
            disimpan dengan aman. Untuk mencegah akses atau pengungkapan yang
            tidak sah atau risiko lain yang serupa, kami berusaha, sejauh
            memungkinkan, untuk melaksanakan langkah-langkah pengamanan teknis,
            fisikl, elektronik dan prosedural berdasarkan ketentuan hukum dan
            perundang-undangan yang berlaku dan standard industri yang berlaku
            untuk melindungi dan mencegah pengolahan Data Pribadi anda yang
            dilakukan secara tidak sah dan melawan hukum, dan pemusnahan, atau
            kerugian yang bersifat insidental, kerusakan, pengubahan,
            pengungkapan atau akses yang tidak sah terhadap Data Pribadi
            anda.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >7.2 Kami akan melakukan update yang wajar terhadap langkah-langkah
            pengamanan kami dari waktu ke waktu dan memastikan bahwa pihak
            ketiga berwenang hanya akan menggunakan Data Pribadi anda untuk
            Tujuan yang dinyatakan dalam Kebijakan ini.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >7.3 Internet bukan media yang aman. Meskipun demikian, kami akan
            menyediakan berbagai prosedur keamanan berkaitan dengan Laman Web
            dan komunikasi elektronik anda dengan kami. Semua karyawan,
            perusahaan patungan/rekanan bisnis, agen, kontraktor, vendor,
            supplier, pihak pengolah data, penyedia produk dan/atau jasa pihak
            ketiga yang mempunyai akses kepada, dan yang berkaitan dengan
            pemprosesan Data Pribadi anda, diwajibkan untuk menjaga kerahasiaan
            Data Pribadi anda.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >7.4 Perlu diketahui bahwa komunikasi melalui Internet, seperti
            e-mail / web mail tidaklah aman kecuali hal tersebut telah
            dienkripsi. Komunikasi anda mungkin dialihkan melalui beberapa
            negara sebelum dikirinmkan – hal ini adalah sifat dari World Wide
            Web / Internet.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >7.5 Kita tidak bertanggungjawab atas setiap akses yang tidak sah
            atau intersepsi atau kehilangan Data Pribadi akibat hal-hal yang
            berada di luar kendali wajar kami.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>8. PEMINDAHAN KE LUAR INDONESIA</i></h2>
    <p>
      <i
        >Fasilitas penyimpanan teknologi informasi dan server kami mungkin
        ditempatkan di negara lain di luar Indonesia. Hal ini mungkin termasuk,
        namun tidak terbatas kepada, contoh-contoh di mana Data Pribadi anda
        dapat disimpan pada server yang terletak di luar Indonesia. Selain itu,
        Data Pribadi anda dapat diungkapkan atau dialihkan kepada entitas yang
        berada di luar Indonesia atau apabila anda mengakses Laman Web dari
        negara-negara di luar Indonesia. Perlu diketahui bahwa entitas asing ini
        mungkin didirikan di negara-negara yang mungkin tidak menawarkan tingkat
        perlindungan data yang setara dengan yang ditawarkan di Indonesia
        berdasarkan ketentuan hukum Republik Indonesia. Anda dengan secara tegas
        menyetujui untuk mengizinkan kami memindahkan Data Pribadi anda di luar
        Indonesia untuk tujuan tersebut. Kami akan berusaha untuk memastikan
        bahawa langkah-langkah yang wajar telah diambil untuk memastikan bahwa
        semua pihak ketiga di luar Indonesia tidak akan menggunakan Data Pribadi
        anda untuk hal-hal yang merupakan bagian dari Tujuan dan untuk
        melindungi kerahasiaan dan privasi Data Pribadi anda secara wajar.</i
      >
    </p>
    <h2><i>9. TAUTAN LUAR</i></h2>
    <ul>
      <li>
        <p>
          <i
            >9.1 Apabila setiap bagian dari Laman Web ini menghubungkan anda ke
            laman web lain, laman web tersebut tidak beroperasi berdasarkan
            Kebijakan ini. Tindakan anda mengakses laman web lain tersebut
            sepenuhnya merupakan risiko anda sendiri. Walapun kami dapat
            menyediakan tautan untuk terhubung ke laman web lain, adanya tautan
            tersebut tidak dapat ditafsirkan sebagai bagian dari Laman Web ini,
            dan kami tidak akan menerima setiap tanggungjawab atau kewajiban
            yang timbul dari laman web tersebut.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >9.2 Begitu juga, jika anda berlangganan suatu aplikasi, konten atau
            produk dari rekanan strategis kami dimana anda kemudian memberikan
            Data Pribadi anda secara langsung kepada pihak ketiga tersebut, Data
            Pribadi tersebut akan tunduk kepada kebijakan perlindungan privasi /
            data personal pihak ketiga tersebut (apabila kebijakan tersebut ada)
            dan bukan kepada Kebijakan ini.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >9.3 Kami menyarankan anda untuk membaca dan memahami penyataan /
            kebijakan perlindungan privasi/ data pribadi yang diunggah di laman
            web lain tersebut untuk memahami prosedur mereka dalam mengumpulkan,
            memproses, menggunakan dan mengungkapkan data pribadi dan sebelum
            menyerahkan Data Pribadi anda ke laman web tersebut.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>10. COOKIES</i></h2>
    <ul>
      <li>
        <p>
          <i
            >10.1 Kami menggunakan teknologi industri standard yang disebut
            "cookies". Cookies adalah berkas informasi kecil yang disimpan pada
            hard drive komputer atau perangkat anda untuk tujuan penyimpanan
            catatan dan digunakan oleh kami untuk melacak kunjungan anda ke
            Laman Web. Cookies dapat digunakan untuk menyimpan preferensi anda
            untuk kemudahan dan kenyamanan anda ketika menggunakan Laman Web
            ini. Jaringan iklan pihak ketiga dapat mengeluarkan cookies terpisah
            milik mereka pada hard drive anda ketika menyediakan iklan
            mereka.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >10.2 Jenis data aliran klik anonim yang dikumpulkan oleh kami
            melalui Cookies meliputi alamat Internet Protokol anda, software web
            browser, tangal dan waktu kunjungan ke Laman Web, dan apakah
            permintaan anda (termasuk permintaan pencarian dan klik pada tautan
            yang merupakan bagian dari Laman Web) dapat dipenuhi dengan
            berhasil. Semua informasi yang dikumpulkan melalui cookies bukan
            merupakan Data Pribadi dan anda dapat dikenali berdasarkan informasi
            ini. Informasi tersebut hanya digunakan dengan tujuan untuk
            mengelola dan menciptakan pengalaman pengguna yang lebih baik dan
            untuk mengidentifikasi area-area untuk peningkatan Laman Web.</i
          >
        </p>
      </li>
      <li>
        <p>
          <i
            >10.3 Penggunaan cookies saat ini merupakan standar industri, dan
            anda akan menemukan cookies tersebut digunakan pada sebagian besar
            laman web utama. Sebagian besar browser pada awalnya diatur untuk
            menerima cookie. Jika anda mau, anda dapat mengatur ulang browser
            anda untuk memberitahu anda apabila anda telah menerima cookies,
            atau menolak untuk menerima cookie. Anda harus memahami bahwa fitur
            tertentu di Laman Web tidak akan berfungsi dengan baik jika anda
            mengatur browser anda untuk tidak menerima cookie.</i
          >
        </p>
      </li>
    </ul>
    <h2><i>11. KONTAK</i></h2>
    <p>
      <i
        >Apabila anda mempunyai pertanyaan mengenai Kebijakan ini, atau
        mempunyai pertanyaan lanjutan, atau ingin membuat pengaduan, akses data,
        atau permintaan pembetulan berkenaan dengan Data Pribadi anda, anda
        dapat menghubungi Petugas Kepatuhan kami melalui &lt;</i
      ><a href="mailto:info@carsome.id" target="_blank"
        ><i><u>info@carsome.id</u></i></a
      ><i>&gt;.</i>
    </p>
    <h2><i>12. BAHASA</i></h2>
    <p>
      <i
        >Apabila terdapat pertentangan antara Kebijakan Perlindungan Data
        Pribadi ini dalam Bahasa Inggris dengan Kebijakan Perlindungan Data
        Pribadi ini dalam Bahasa Indonesia, maka Kebijakan Perlindungan Data
        Pribadi dalam Bahasa Indonesia yang akan berlaku.</i
      >
    </p>
    <p><i> </i></p>
    <p>
      <i><b>Tanggal: 1 Januari 2021</b></i>
    </p>
  </div>
</template>


<style scoped>
.container {
  padding: 24px 16px 16px 16px;
  width: 100%;
  box-sizing: border-box;
}

p {
  margin-top: 8px;
  text-align: start;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
  font-style: normal;
}

.switch li:nth-child(even){
  color: #696c71;
}

h2 {
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  font-style: normal;
  color: #2e2e2e;
  margin-top: 24px;
  font-weight: 700;
}

ul {
  padding-left: 12px;
}
</style>
